/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RewardMultiplierEventTargetsDto } from "./RewardMultiplierEventTargetsDto";
export type CreateRewardMultiplierEventDto = {
  /**
   * 이벤트명
   */
  name: string;
  /**
   * 정답 리워드 배수 (1 초과)
   */
  multiplier: number;
  /**
   * 대상 설정
   */
  targets: RewardMultiplierEventTargetsDto;
  /**
   * 시작일시
   */
  startAt: string;
  /**
   * 종료일시
   */
  endAt: string;
  /**
   * 상태
   */
  status?: CreateRewardMultiplierEventDto.status;
};
export namespace CreateRewardMultiplierEventDto {
  /**
   * 상태
   */
  export enum status {
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
  }
}
